import React from "react";
import { Table, Grid, Dimmer, Loader, Accordion, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import {
  getRequestHeadersService,
  getDepartmentsByUser,
  getWorkSheet,
  getWorkSheetBySearchCriteria
} from "../../services/offpriceServices";
import { css } from 'emotion';
import SearchWorksheet from "./SearchWorksheet";
const style = css`
  &.create-cdp-home-color {
    background: #35c9ae14!important;
    color: rgba(0,0,0,.95)!important;
  }`

export default class Home extends React.Component {

  constructor(props) {
    super(props);
  }    

  
  
  render() {
  return (
    <div>
      <SearchWorksheet></SearchWorksheet>
    </div>
  );
  }
}


// WEBPACK FOOTER //
// ./components/home/Home.js